// базовый шаблон вкладок раздела "Карты"
const defaultMapMenuItems: any = [
    {
        type: 'map',
        title: "Все объекты",
        url: "/app/map/AllRoadObjects",
        imageIndex: "0030"
    },
    {
        type: 'map.diagnostics',
        title: "Основные характеристики",
        imageIndex: "6026",
        children: [
            {
                type: 'map.highwayNetworkSegments',
                title: "Участки опорной сети",
                url: "/app/map/HighwayNetworkSegments",
                imageIndex: "1514"
            },
            {
                type: 'map.roadBedLayerSegments',
                title: "Типы дорожной одежды",
                url: "/app/map/RoadBedLayerSegments",
                imageIndex: "4288"
            },
            {
                type: 'map.roadCategorySegments',
                title: "Техническая категория",
                url: "/app/map/RoadCategorySegments",
                imageIndex: "1625"
            },
        ]
    },
    {
        type: 'map.diagnostics',
        title: "Состояние",
        imageIndex: "6026",
        children: [
            {
                type: 'map.diagnosticsSegments',
                title: "Данные диагностики",
                url: "/app/map/RoadDiagnosticsSegments",
                imageIndex: "5967"
            },
            {
                type: 'map.pathNormativities',
                title: "Нормативное состояние",
                imageIndex: "5967",
                children: [
                    {
                        type: 'map.normativities.roughness',
                        title: "Продольная ровность покрытия",
                        url: "/app/map/PathNormativities/Roughness",
                        imageIndex: "5967"
                    },
                    {
                        type: 'map.normativities.defects',
                        title: "Наличие дефектов",
                        url: "/app/map/PathNormativities/Defects",
                        imageIndex: "5967"
                    },
                    {
                        type: 'map.normativities.gaugeDepth',
                        title: "Поперечная ровность (колейность)",
                        url: "/app/map/PathNormativities/GaugeDepth",
                        imageIndex: "5967"
                    },
                    {
                        type: 'map.normativities.strength',
                        title: "Прочность дорожной одежды",
                        url: "/app/map/PathNormativities/Strength",
                        imageIndex: "5967"
                    },
                    {
                        type: 'map.normativities.cohesion',
                        title: "Коэффициент сцепления",
                        url: "/app/map/PathNormativities/Cohesion",
                        imageIndex: "5967"
                    },
                    {
                        type: 'map.normativities.groupings',
                        title: "По всем показателям",
                        url: "/app/map/PathNormativities/Total",
                        imageIndex: "5967"
                    },
                    {
                        type: 'map.normativities.groupings',
                        title: "По нескольким показателям",
                        url: "/app/map/PathNormativities/group",
                        imageIndex: "5967"
                    },
                ]
            },
        ]
    },
]

// базовый шаблон вкладок в конце раздела "Карты"
export const defaultEndMapMenuItems: any = [
    {
        type: 'transport',
        title: "Транспорт",
        imageIndex: "9998",
        children: [
            {
                type: 'transport.now',
                title: "Сейчас",
                url: "/app/map/transport/now",
                imageIndex: "9998"
            },
            {
                type: 'transport.history',
                title: "История",
                url: "/app/map/transport/history",
                imageIndex: "0244"
            },
        ]
    },
    {
        type: 'weather',
        title: "Метеостанции",
        url: "/app/weather",
        imageIndex: "4244"
    },
    {
        type: 'map.WeatherStations',
        title: "Метеостанции",
        url: "/app/map/WeatherStations",
        imageIndex: "4244"
    },
    {
        type: 'gismeteo',
        title: "Радар осадков и гроз (Gismeteo)",
        url: "/app/map/gismeteo/precipitation",
        imageIndex: "gismeteo_logo",
        imageType: "localIcon"
    },
    {
        type: 'projects',
        title: "Проекты",
        url: "/app/projects",
        imageIndex: "0030"
    },
    {
        type: 'cameras',
        title: "Дорожные камеры",
        url: "/app/cameras",
        imageIndex: "0520"
    },
]

// базовый шаблон вкладок раздела "Аналитика"
const defaultAnalyticsMenuItems: any = [
    {
        type: "overallAnalytics",
        title: "Общая аналитика",
        url: "/app/overallAnalytics",
        imageIndex: "0203"
    },
    {
        type: 'analytics',
        title: "По нескольким типам",
        url: "/app/analytics/selectObjects",
        imageIndex: "0030"
    },
]

// базовый шаблон вкладок раздела "Диагностика"
const defaultDiagnosticsMenuItems: any = [
    {
        type: "pathNormativities",
        title: "Состояние дорог",
        url: "/app/diagnostics/pathNormativities",
        imageIndex: "0203"
    },
    {
        type: "roadDiagnosticsSegments",
        title: "Участки диагностики",
        url: "/app/diagnostics/diagnosticsSegments",
        imageIndex: "6027"
    },
    {
        type: "roadMeasureResults",
        title: "Результаты измерений",
        imageIndex: "6026",
        children: [
            {
                type: 'roadMeasureResults.roughness',
                title: "Продольная ровность покрытия",
                url: "/app/diagnostics/diagnosticsMeasureResults/RoadMeasureRoughness",
                imageIndex: "5967"
            },
            {
                type: 'roadMeasureResults.defectsGOST',
                title: "Наличие дефектов по ГОСТ Р 50597",
                url: "/app/diagnostics/diagnosticsMeasureResults/DefectSegmentGOST",
                imageIndex: "5967"
            },
            {
                type: 'roadMeasureResults.defectsODM',
                title: "Наличие дефектов по ОДМ 218.4.039",
                url: "/app/diagnostics/diagnosticsMeasureResults/DefectSegmentODM",
                imageIndex: "5967"
            },
            {
                type: 'roadMeasureResults.gaugeDepth',
                title: "Поперечная ровность (колейность)",
                url: "/app/diagnostics/diagnosticsMeasureResults/RoadMeasureGaugeDepth",
                imageIndex: "5967"
            },
            {
                type: 'roadMeasureResults.strength',
                title: "Прочность дорожной одежды",
                url: "/app/diagnostics/diagnosticsMeasureResults/RoadMeasureStrength",
                imageIndex: "5967"
            },
            {
                type: 'roadMeasureResults.cohesion',
                title: "Коэффициент сцепления",
                url: "/app/diagnostics/diagnosticsMeasureResults/RoadMeasureCohesion",
                imageIndex: "5967"
            },
        ]
    }
]

// базовый шаблон вкладок админ-панели
const defaultPersonalAdminMenuItems: any = [
    {
        type: 'roadWorks',
        title: "Дорожные работы",
        url: "/app/admin",
        imageIndex: "6083"
    },
]

// базовый шаблон вкладок меню
export const defaultMenuStructure: any = [
    {
        type: 'admin',
        title: "ОУДХ",
        url: "/app/admin",
        imageIndex: "2389",
        selectedAdmin: "ФКУ «Центравтомагистраль»"
    },
    {
        type: 'mapMenu',
        title: "Карта",
        imageIndex: "0030",
        children: defaultMapMenuItems
    },
    {
        type: 'analyticsMenu',
        title: "Аналитика",
        imageIndex: "0203",
        children: defaultAnalyticsMenuItems
    },
    {
        type: 'statementsMenu',
        title: "Ведомости",
        imageIndex: "0740",
    },
    {
        type: 'tables',
        title: "Таблицы",
        imageIndex: "0427",
        children: []
    },
    {
        type: "diagnosticsMenu",
        title: "Диагностика",
        imageIndex: "5967",
        children: defaultDiagnosticsMenuItems
    },
    {
        type: "additional",
        title: "Дополнительно",
        imageIndex: "6137",
        children: []
    },
    {
        type: 'reports',
        title: "Документы",
        imageIndex: "0740"
    },
    {
        type: 'favourites',
        title: "Закладки",
        url: "/app/favourites",
        imageIndex: "0552"
    },
    {
        type: 'pano',
        title: "Панорамы",
        url: "/app/panorama",
        imageIndex: "6352"
    },
    {
        type: 'personaladmin',
        title: "Администрирование",
        imageIndex: "0241",
        children: defaultPersonalAdminMenuItems
    },
    {
        type: 'info',
        title: "Информация",
        url: "/app/info",
        imageIndex: "0135"
    },
    {
        type: 'profile',
        title: "Мой профиль",
        imageIndex: "0135"
    },
    {
        type: 'users',
        title: "Пользователи",
        imageIndex: "0135"
    },
    {
        type: 'feedback',
        title: "Оставить сообщение",
        imageIndex: "0241"
    },
    {
        type: 'exit',
        title: "Выход",
        imageIndex: "0134"
    }
]